import axios from "axios";

export default async function PatchData(url, data) {
  try {
    const response = await axios.patch(url, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    });
    return response.data; // Return the response data if needed
  } catch (error) {
    console.error("Error updating data", error);
    throw error; // Rethrow the error for further handling if necessary
  }
}